import Box from 'components/shared/Box'
import { formatPrice } from 'helpers/helpers'
import { PriceWrapper } from 'components/shared/Reservation/styles'
import styled, { css, DefaultTheme } from 'styled-components'
import Text from 'components/shared/Text'
import { Align } from 'components/shared/Box'

interface TicketRowProps {
    children: React.ReactNode
    price: number
    isDisabled?: boolean
    isReturned?: boolean
    align?: Align | [Align, Align]
    theme?: DefaultTheme
    hasUnwrappedDescriptionOnMobile?: boolean
    hasSmallerGap?: boolean
}

const TicketRowWrapper = styled(Box)<{ isReturned?: boolean }>`
    position: relative;

    ${({ isReturned }) =>
        isReturned &&
        css`
            ${Text}:not(:has(${Text})) {
                text-decoration: line-through;
            }
        `};
`

const TicketRow = ({
    children,
    price,
    isDisabled,
    isReturned,
    align,
    theme,
    hasUnwrappedDescriptionOnMobile,
    hasSmallerGap,
}: TicketRowProps) => {
    const hasDarkMode = theme?.mode === 'dark'

    const priceColor = (() => {
        if (hasDarkMode) return 'primary_500'
        return isDisabled || isReturned ? 'grayscale_700' : 'secondary_500'
    })()

    return (
        <TicketRowWrapper
            direction="row"
            align={align ?? ['flex-start', 'center']}
            justify="space-between"
            gap={hasSmallerGap ? [8, 24] : [0, 40]}
            isFullWidth
            isReturned={isReturned}
        >
            {children}

            <PriceWrapper
                mt={[0, 2]}
                hasNoWrap
                variant="bodySmallStrong"
                color={priceColor}
                align="right"
                isAbsoluteOnMobile={hasUnwrappedDescriptionOnMobile}
            >
                {formatPrice(price, true)}
            </PriceWrapper>
        </TicketRowWrapper>
    )
}

export default TicketRow
